module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<header></header> <div class=\"card card-body filter-card\"> <div id=\"carrier_picker\" class=\"mr-4\"></div> <div id=\"service_priority_picker\" class=\"mr-4\"></div> <div id=\"daterange_pickers\"></div> </div> <div id=\"tracking_status_report_list\"></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/tracking_status_report/template.ejs
// module id = 1846
// module chunks = 1